<template>
  <div class="home" >
    <!-- <ImageView
      v-for="img in imgUrl" 
      :imgUrlProps="img" 
      :width="200" 
      :height="200" 
      :key="img" 
      :preView="true" 
      :preViewImgData="imgUrl"
    /> -->
    <van-button type="default" @click="alert">弹出弹窗</van-button>
    <!-- <CardModal v-show="show" v-on:onCloseModal="onCloseModal" /> -->
    <van-list
      v-model="isLoading"
      :finished="isFinished"
      finished-text="没有更多了"
      @load="onLoad"
    >
        <div class="listCell" v-for="list in listData" :key="list.title" @click="goAbout">
          <span>{{list.title}}</span>
          <img v-if="list.imgUrl" :src="list.imgUrl[0]" style="width: 100%">
        </div>
    <slot name="loading">
      <Loading />
    </slot>   
    </van-list>
  </div>
</template>

<script>
// @ is an alias to /src
// import CardModal from '@/components/CardModal.vue'
import ImageView from '@/components/ImageView.vue'
import Loading from '@/components/Loading.vue'
import { mapState, mapGetters } from 'vuex'
import { setTimeout } from 'timers';

export default {
  name: 'demo',
  components: {
    CardModal,
    ImageView,
    Loading
  },
  data (){
    return {
      show: false,
      listData: [],
      isLoading: false,
      isFinished: false,
      page: 1,
      pageNumber: 1,
    }
  },
  computed: {
    // Getting Vuex State from store/modules/movie
    ...mapState({
      imgUrl: state => state.demo.imgUrl,
      isListData: state => state.demo.listData,
      isPage: state => state.demo.page,
      isPageNumber: state => state.demo.pageNumber,
    }),

    ...mapGetters({
      imgUrlError: "imgUrlError"
    })
  },
  watch:{
    isPage(val){
      this.page = val;
    },
    isPageNumber(val){
      this.pageNumber = val;
    },
    isListData(val){
      this.listData = val;
    } 
  },
  methods: {
    //onLoad 加载数据
    onLoad(){
      const { page } = this;
      setTimeout(()=>{
        this.$store.dispatch({
            type: 'loadMore',
            payload:{
              page: page
            } 
          }).
          then(res => {
            const { page, pageNumber } = this;
            if(page > pageNumber){
              this.isFinished = true;
            }
            this.isLoading = false;
            this.$store.dispatch({
              type: 'plusPage'
            })
        })}, 1000)
    },
    goAbout(){
      this.$router.push({name: 'card'})
    },
    // Dispatching login
    login: function () {
      this.$store.dispatch('loadMore').
      then(res => {
      // this.show= true;
    })
    },
    alert(){
      this.show= true;
      // this.isReturn = true;
    },
    onCloseModal(value){
      this.show= value;
    }
  },
   beforeRouteLeave (to, from, next) {
    // 导航离开该组件的对应路由时调用
    if (to.name === 'home') {
      this.$store.dispatch({
        type: 'removeIncludeData',
        payload: 'demo'
      })
      this.$store.dispatch({
        type: 'initData'
      })
    } else {
    }
    next()
  },
  created () {
    // Getting movies data on created
    // this.login()
  }
}
</script>
<style scoped lang="scss">
.home{
  display: flex;
  flex-direction: column;
  background-color: #CECECE;
}
</style>